import { Component, OnInit, Input } from '@angular/core';

interface imageTextInterface {
    servingSize: number,
    servingUnit: number,
    imageUrl: string,
    name: string,
}

interface nutritionInfoInterface {
    totalCalories: number,
    carbohydrates: number,
    protein: number,
    fat: number,
    totalCaloriesFromCarbs: number,
    totalCaloriesFromProtein: number,
    totalCaloriesFromFat: number,
}

@Component({
    selector: 'clearcals-image-text',
    templateUrl: './image-text.component.html',
    styleUrls: ['./image-text.component.scss'],
})
export class ImageTextComponent implements OnInit {
    @Input() imageText! : imageTextInterface
    @Input() nutritionInfo! : nutritionInfoInterface
    @Input() convertedServingUnit!: number
    constructor() {}

    ngOnInit(): void {}
}
